import { makeStyles } from "@mui/styles";
import AvatarList from "@metacrm/metacrm-material-ui/dist/AvatarList";
import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import SelectChain from "features/metadesk/components/SelectChain";
import { useFetchOrcaOnchainDetails } from "features/metadesk/orca/redux/fetchOrcaOnchainDetails";
import { selectEntityChainList } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";
import { Box, Grid } from "@mui/material";
import { useFetchEntityConfig } from "features/metadesk/redux/hooks";

const OrcaPosition = ({ selectedUserAddress }) => {
  const {
    orcaOnchainDetails,
    fetchOrcaOnchainDetailsPending,
    fetchOrcaOnchainDetails,
  } = useFetchOrcaOnchainDetails();
  const allLiquidity = useMemo(() => {
    const result = [];
    _.map(_.get(orcaOnchainDetails, "solana"), (data) => {
      result.push({
        img: [
          { label: data?.tokenA?.symbol, src: data?.tokenA?.imageUrl },
          { label: data?.tokenB?.symbol, src: data?.tokenB?.imageUrl },
        ],
        name: `${data?.tokenA?.symbol}/${data?.tokenB?.symbol}`,
        value: data?.value,
        chainId: "solana",
      });
    });
    return result;
  }, [orcaOnchainDetails]);

  const { entityConfig } = useFetchEntityConfig();
  const chainList = useSelector(selectEntityChainList);

  const chains = [
    { name: "All", id: 0 },
    ..._.filter(chainList, function (o) {
      return _.includes(entityConfig.chainIds, o.id);
    }),
  ];

  useEffect(() => {
    if (selectedUserAddress) {
      fetchOrcaOnchainDetails({ selectedUserAddress: selectedUserAddress });
    }
  }, [selectedUserAddress]);

  const renderLiquidityRow = (field1, field2) => {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: "4px",
          padding: "10px 8px",
          marginTop: "8px",
          fontSize: "12px",
        }}
      >
        <Grid container alignItems="center">
          <Grid item xs={12} sm={6}>
            {field1}
          </Grid>
          <Grid item xs={12} sm={6}>
            {field2}
          </Grid>
        </Grid>
      </Box>
    );
  };

  return (
    <Box color="#555" p="16px" bgcolor="#FAFAFD">
      <Box fontSize={"12px"} fontWeight={500} mb="8px">
        Liquidity Total Value:
      </Box>
      <Box fontSize={"16px"} mb="24px" fontWeight={700}>
        {fetchOrcaOnchainDetailsPending ? (
          <StyledSkeleton animation="wave" sx={{ width: "40%" }} />
        ) : (
          `$${parseFloat(_.sumBy(allLiquidity, "value") || 0).toFixed(1)}`
        )}
      </Box>
      <Box fontSize={"18px"} fontWeight={700} mt="24px" mb="8px">
        Liquidity Holding Sheet
      </Box>
      <Grid
        container
        alignItems="center"
        style={{ fontSize: "10px", fontWeight: 500 }}
      >
        <Grid item xs={12} sm={6}>
          Pool
        </Grid>
        <Grid item xs={12} sm={6}>
          Position Value
        </Grid>
      </Grid>
      {fetchOrcaOnchainDetailsPending
        ? Array.from({ length: 5 }).map((_, i) =>
            renderLiquidityRow(
              <StyledSkeleton animation="wave" sx={{ width: "40%" }} />,
              <StyledSkeleton animation="wave" sx={{ width: "80%" }} />
            )
          )
        : _.map(_.orderBy(allLiquidity, ["value"], ["desc"]), (data) => {
            return renderLiquidityRow(
              <Box className="startRow">
                <AvatarList lists={data.img} />
                <Box ml="4px" fontWeight={600}>
                  {data.name}
                </Box>
              </Box>,
              <Box fontWeight={500}>{`$${parseFloat(data.value).toFixed(
                1
              )}`}</Box>
            );
          })}{" "}
    </Box>
  );
};

export default OrcaPosition;
